<template>
  <div class="fast">
    <div class="fast__innerwrap">
      <div class="fast__row">
        <div class="fast__video-wrapper">
          <video class="fast__video" ref="video" :src="video" muted plays-inline autoplay></video>
        </div>
        <div class="fast__text">
          <h1 class="fast__title" v-html="benefit.title"></h1>
          <div class="fast__content">
            <ul>
              <li v-for="(item, index) in benefit.list" :key="index" v-html="item"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fast',
  props: ['benefit', 'active'],
  computed: {
    video() {
      return `static/${this.benefit.video}`;
    },
  },
  data() {
    return {
      videoPlayed: false,
    };
  },
  mounted() {
    if (!this.active) {
      this.$refs.video.pause();
    } else {
      this.videoPlayed = true;
    }
  },
  watch: {
    active(newActive) {
      if (newActive === true && !this.videoPlayed) {
        this.videoPlayed = true;
        setTimeout(() => {
          this.$refs.video.play();
        }, 500);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/helpers';

.fast {
  @include section;
  // background: $c_black;
  // color: $c_white;
  @include section-bg-dot('../');

  &__innerwrap {
    // width: 10/12 * 100%;
    background: $c_grey--light;
  }

  &__row {
    display: flex;
  }

  &__video-wrapper {
    width: calc(6/12 * 100% - 10px);
    margin-left: -30px;
    margin-right: 40px;
    flex-shrink: 0;
    position: relative;
    margin: 10px 40px -127px -30px;

    &::after {
      content: '';
      display: block;
      width: 240px;
      height: 240px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('../../assets/fast_plus.svg');
      position: absolute;
      top: -65px;
      right: -4px;
      transform: translateX(50%);
    }
  }

  &__video {
    display: block;
    width: 100%;
  }

  &__text  {
    width: calc(6/12 * 100% - 10px);
    margin-left: 30px;
    flex-shrink: 0;
  }

  &__title {
    @include font-heading;
  }

  &__content {
    @include font-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Fast.vue